export class SearchResultItem {
    score: number;
    highlights: any;
}
